<div [ngClass]="options?.cssClasses ? options.cssClasses : 'w-100'">
  <label #contactsPhoneLabel id="bb-create-contact-phone-label" data-role="contact-account-create-phone" class="bb-label mb-2">
    {{ options?.label || label }}
  </label>

  <div class="sbk-phone-number-input__shell" [class.sbk-phone-number-input__shell--invalid]="control?.touched && control?.invalid"
    [class.sbk-phone-number-input__shell--disabled]="isNonEditable()">
    <div class="sbk-phone-number-input__prefix phone-container">
      <img src="assets/phone_image.svg" alt="" />
      <span class="bb-text-support ml-1">+254</span>
    </div>
    <div class="sbk-phone-number-input__field">
      <bb-input-text-ui [formControl]="control" [placeholder]="options?.placeholder || ''"
        [maxLength]="options?.maxLength || maxLength" [minLength]="options?.minLength || minLength"
        [aria-labelledby]="contactsPhoneLabel.id" aria-describedby="example-number" data-role="new-contact-phone"
        [readonly]="isDisabled()" [disabled]="isDisabled()">
      </bb-input-text-ui>
    </div>
  </div>

  <small *ngIf="showHelpText" id="example-number" class="d-block bb-text-support bb-text-default mt-2">{{
    helpText || options.helpText
    }}</small>
  <div>
    <sbk-payord-validation-message [control]="control"
      [validationMessages]="options?.validationMessages || validationMessages"
      [label]="options?.label || label"></sbk-payord-validation-message>
  </div>
</div>
